import {Header, Layout} from "@components/common";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {fetchJson, getShopNavigation, redirectTo404Page} from "../index";
import {useState} from "react";
import {Button} from "@components/ui";
import s from "./jobs.module.scss";
import {useTranslation} from "next-i18next";
import {useRouter} from "next/router";
import Job from "@components/CmsBlocks/Job";
import Head from "next/head";

const PAGE_SIZE = 9;

export function getJobs(locale: string, page: number, pageSize: number, search: string | null = null) {
  return new Promise(async (resolve) => {
    let url = `${process.env.NEXT_PUBLIC_API_URL || "http://localhost:1337"}/api/jobs?populate=*&sort[0]=Date%3Adesc&pagination[page]=${page}&pagination[pageSize]=${pageSize}&locale=${locale}`;
    console.log('url', url);
    if (search) {
      url += "&filters[title][$containsi]=" + search;
    }
    const jobs: any = await fetchJson(
      url,
      null
    );
    resolve(jobs);
  });
}

export async function getServerSideProps(context: any) {
  try {
    const { locale } = context;
    const url = `${process.env.NEXT_PUBLIC_API_URL || "http://localhost:1337"}`;

    const jobs = await getJobs(locale, 1, PAGE_SIZE);

    return {
      props: {
        ...(await serverSideTranslations(locale, ["common", "home"])),
        ...(await getShopNavigation(locale)), // makes "ShopNavigationColumn" property available on page props
        jobs,
        locale
      }
    };
  } catch (error) {
    console.error(error)
    return  redirectTo404Page();
  }
}

export default function Jobs(data: any) {
  let [jobs, setJobs] = useState(data.jobs);
  let [locale, setLocale] = useState(data.locale);
  let [page, setPage] = useState(1);
  let [pageSize, setPageSize] = useState(PAGE_SIZE);
  let [searchString, setSearchString] = useState();
  const router = useRouter();
  const query = router.query;
  async function previousPage() {
    page = page - 1;
    setPage(page);
    const jobs = await getJobs(locale, page, pageSize, null);
    setJobs(jobs);
  }
  async function nextPage() {
    page = page + 1;
    setPage(page);
    const jobs = await getJobs(locale, page, pageSize, null);
    setJobs(jobs);
  }
  async function searchJobs() {
    page = 1;
    setPage(page);
    const jobs = await getJobs(locale, page, pageSize, searchString);
    setJobs(jobs);
  }

  function changedSearchString(event: any) {
    setSearchString(event.target.value);
  }
  const { t } = useTranslation("common");
  return (
    <>
      <Head>
        <>
          <title>Jobs</title>
        </>
      </Head>

      <div className="container-rg mb-6">
      <Header></Header>
      <div className={s.searchBar}>
        <label className="hidden" htmlFor={'search'}>
          {t("search")}
        </label>
        <input type="text"
               value={searchString}
               id={'search'}
               className={s.input}
               onChange={(e) => { changedSearchString(e) }}
               placeholder={t("search-jobs")}
               aria-label="Search"/>
        <Button variant={"ghost"} onClick={(e) => { searchJobs() }}>
          <svg className={s.icon} fill="currentColor" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
            />
          </svg>
        </Button>
      </div>
      <main className={s.body}>
        <div className="lg:w-4/4 lg:pl-5 mt-10">
          { jobs?.data && jobs.data.slice(0).map((job: any, index: any) => {
            return <Job key={`job-index-${index}`} { ...job } />
          } )
          }
        </div>
      </main>
      <div className="text-center mt-6 mb-10">
      {
        jobs?.meta?.pagination && <div>
          <Button className="mr-3"
                  variant={'ghost'}
                  onClick={(e) => { previousPage() }}
                  disabled={page === 1}>
            {t("previous")}
          </Button>
          <Button variant={'ghost'}
                  onClick={(e) => { nextPage() }}
                  disabled={jobs.meta.pagination.pageCount < 2 || page === jobs.meta.pagination.pageCount}>
            {t("next")}
          </Button>
        </div>
      }
      </div>
    </div>
    </>
  )
}

Jobs.Layout = Layout
